////
/// ============================================================================
/// COMPONENT / Swiper Events
/// ============================================================================
///
/// @group components
////

import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

export default () => {
    let element = document.querySelector('.js-events-city');

    if (!element) {
        return;
    }

    let swiper = new Swiper(element, {
        modules: [Autoplay, Navigation],
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
    });
};
